export default function CTASection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-[#F5F2EE] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Main CTA Block */}
        <div className="relative bg-[#011820] rounded-3xl overflow-hidden px-8 md:px-16 py-16 md:py-20 text-center">
          {/* Background decoration */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-[#026A86]/10 rounded-full -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#026A86]/5 rounded-full translate-x-1/3 translate-y-1/3" />

          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 border border-[#026A86]/40 rounded-full px-4 py-1.5 mb-6">
              <span className="text-[#026A86] text-xs font-medium tracking-widest uppercase">
                Vamos Conversar
              </span>
            </div>

            <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
              Vamos conversar sobre
              <br />
              <span className="text-[#026A86]">o seu projecto</span>
            </h2>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={() => handleScroll('#contacto')}
                className="flex items-center gap-3 bg-[#026A86] hover:bg-[#035f78] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap group"
              >
                Fale Connosco
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200" />
              </button>
              <a
                href="tel:+244925434499"
                className="flex items-center gap-2 text-white/60 hover:text-white text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line" />
                +244 925 434 499
              </a>
            </div>
          </div>
        </div>

        {/* Image strip */}
        <div className="mt-8 grid grid-cols-3 gap-4 h-40 md:h-52">
          <div className="rounded-2xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/b7cb81837dd39d09f17da3543cfc7756.jpeg"
              alt="Parceria"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="rounded-2xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/9dd0e1b813f0b29779722e7c470fb210.jpeg"
              alt="Estratégia"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="rounded-2xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/5e936c0a78f217bbe07e952eefe9f071.jpeg"
              alt="Angola"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
